---
nb:
  feature_requests:
    categories:
      api_developer: API/Utvikler
      feedback: Tilbakemelding
      new_feature: Ny funksjon
    create_request: Lag forespørsel
    delete: Slett
    edit_request: Rediger forespørsel
    filter_category: Filtrer på kategori
    filter_status: Filtrer på status
    mail_support: Mail til support
    model_name: Forespørsel
    only_admins_can_delete: Kun administratorer kan slette en forespørsel
    plural: Forespørsler
    publish: Opprett
    save: Lagre
    statuses:
      coming_soon: Kommer snart
      investigating: Undersøker
      launched: Lansert
      new: Ny
      not_planned: Ikke planlagt
